/* eslint-disable react/no-unknown-property */
import { FC } from 'react';

export const WarningIcon: FC = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="warning-icon">
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#FEF0C7" />
    <path
      d="M27.9998 25V29M27.9998 33H28.0098M26.6151 19.8917L18.3902 34.0983C17.934 34.8863 17.7059 35.2803 17.7396 35.6037C17.769 35.8857 17.9168 36.142 18.1461 36.3088C18.4091 36.5 18.8643 36.5 19.7749 36.5H36.2246C37.1352 36.5 37.5904 36.5 37.8534 36.3088C38.0827 36.142 38.2305 35.8857 38.2599 35.6037C38.2936 35.2803 38.0655 34.8863 37.6093 34.0983L29.3844 19.8917C28.9299 19.1065 28.7026 18.714 28.4061 18.5821C28.1474 18.4671 27.8521 18.4671 27.5935 18.5821C27.2969 18.714 27.0696 19.1065 26.6151 19.8917Z"
      stroke="#DC6803"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#FFFAEB" strokeWidth="8" />
  </svg>
);
